module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "p_heading_",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Perfect 10")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_norm-noindent"
  }, [_vm._v("By Sean Michael")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Despite a life-threatening injury sustained in a vaulting accident, top gymnast Christopher Allen is determined to get back to his former perfect condition and compete again. Brian Rainings is a coach in need of someone to believe in, and he takes Chris on, admiring the spirit and determination that drives Chris to succeed. And admiring the sturdy, muscled body Chris maintains.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Admiration soon leads to something much hotter as they train together. From their scorching first kiss, Brian and Chris’s chemistry is obvious, but they have a long road ahead to get Chris back into shape. Months of hard work lead to success, with Chris gaining strength every day and finally finding the elusive sponsor he needs for financial support. Secrets, hidden dangers, and family troubles plague them, though, and they have to face the fact that Chris might never compete again and score that perfect ten.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98d33330","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OPS/section0002.vue
// module id = 60
// module chunks = 0